import { Component, OnInit, Input, OnDestroy, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MdocsSopsService } from '../services/mdocssops.services';
import { MdocsSopsmodel } from '../models/mdocssops.models';
import { MessageService } from 'primeng/api';
import { AuthService } from '../../auth.service';
import { environment } from '../../../environments/environment';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-sops',
  templateUrl: './sops.component.html',
  styleUrls: ['./sops.component.css']
})
export class SopsComponent implements OnInit {
  mdocsForm: FormGroup;
  @Input() disabled = false;
  submitted = false; requiredmsg = false;
  selectedtId = 0; status = false;
  selectedDocument: File; documentUpload = "";
  currentDate = new Date();
  unitId = 0; envurl = environment.waterMeter; closeResult: string;docDescription="";
  mdoclst: MdocsSopsmodel[] = [];mdocSops=new MdocsSopsmodel();
  constructor(private fb: FormBuilder, private messageService: MessageService,private modalService: NgbModal, private authService: AuthService, private mdocsService: MdocsSopsService) {
    this.unitId = this.authService.getUser().unitId;
   }

  ngOnInit() {
    this.createForm();
    const startDateIn = new Date();
    //   this.mdocsForm.get('FromDate').setValue(startDateIn);
    // this.retrieveunitdetails();
    this.getList();
    this.mdocsService.MdocsSopsActionObservable.subscribe((consuptId: number) => {
      if (consuptId) {
        this.selectedtId = consuptId;
        // this.mdocsService.ge(consuptId).subscribe((effmodel: Consumptionmodel) => {
        //   console.log(effmodel);
        //   this.populateroadTaxtDetais(effmodel);

        // });
      }
      this.requiredmsg = false;
    });
  }
  createForm() {
    this.mdocsForm = this.fb.group({
      //vendorId: ['', Validators.required],
      Title: ['', Validators.required],
      Description: ['', Validators.required],

    });

    if (this.mdocsForm.valid) {
      this.disabled = true;
    }
  }
  onSelectedDocChange(event) {
    if (event.target.files.length > 0) {
      this.selectedDocument = event.target.files[0];
    }
  }
  formreset() {
    this.mdocsForm.reset();
    //this.mdocsForm.get("UnitID").setValue('');
  }
  // retrieveunitdetails() {
  //   this.unitservice.getallUnitWaterList().subscribe((resp: any) => {
  //     if (resp) {
  //       this.unitwaterlst = resp.UnitMasterList;
  //     }
  //   });
  // }
  // populateroadTaxtDetais(getDetails: Consumptionmodel) {
  //   //this.roadtaxForm.get("vendorId").setValue(getDetails.vendorId);
  //   this.mdocsForm.get("UnitID").setValue(getDetails.UnitID);
  //   //const roadTaxValidity = new Date(getDetails.roadTaxValidity);
  //   this.mdocsForm.get("FromDate").setValue(this.formatDate(getDetails.FromDate));
  //   this.mdocsForm.get("Addition").setValue(getDetails.Addition + "");
  //   this.mdocsForm.get("Reduction").setValue(getDetails.Reduction + "");
  //   this.mdocsForm.get("Reamrks").setValue(getDetails.Reamrks + "");
  //   this.selectedtId = getDetails.ID;
  //   // this.status = getDetails.Status;

  // }

  registerMdoc() {
    if (this.mdocsForm.valid) {
      this.requiredmsg = false;
      const MdocData = this.mdocsForm.value;
      MdocData.Sopsid = this.selectedtId;
      MdocData.UnitID = this.authService.getUser().unitId;
      MdocData.Status = this.status;
      // EffData.Status = this.status;
      const uploadData = new FormData();
      //  uploadImageData.append('pPT', MdocData)
      uploadData.append('file', this.selectedDocument);
      uploadData.append('mdocdata', JSON.stringify(MdocData));
      this.mdocsService.addMdocsSops(uploadData).subscribe((response: any) => {
        console.log(response);
        var statusval = this.selectedtId == 0 ? "added" : "update";
        this.messageService.add({ severity: 'success', summary: 'Mdocs Sops ' + statusval + ' successfully', detail: '', sticky: false });
        this.selectedtId = 0;
        this.formreset();
        this.status=false;
        this.mdocsService.notifyMdocsSopsreated();
      });
    }


  }
  getList() {
    this.mdocsService.GetMdocsSopsList(this.unitId, null).subscribe((resp: any) => {
      console.log(resp.MDocPptDetails);
      this.mdoclst = resp.MDocSopsDetails;
    });
  }
  updateStatus(doc: MdocsSopsmodel) {
    this.mdocsService.UpdateStatus(doc.Sopsid, doc.Status).subscribe((resp: any) => {
      var statusval=doc.Status==true?"Active":"InActive";
      this.messageService.add({ severity: 'success', summary: 'Status '+statusval+' successfully', detail: '', sticky: false });
    });
  }
  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }
  openViewForm(content, docModel: MdocsSopsmodel) {
    this.mdocSops = docModel;
    this.modalService.open(content, { windowClass: "my-class" }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;

    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });

  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }

  }
}